import { render, staticRenderFns } from "./DashboardUserSulut.vue?vue&type=template&id=00537742&lang=pug"
import script from "./DashboardUserSulut.vue?vue&type=script&lang=js"
export * from "./DashboardUserSulut.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports